module.exports = __webpack_public_path__ + "static/media/ie.f8d9aeb4.svg";